export default "__VITE_ASSET__CiSNTuWw__"